import { HttpGet, HttpPost, HttpPost2 } from "../../utils/lib/api.request.js";
import {
  randomWord,
  getTimeStamp,
  tempLoginSign,
  loginSign,
} from "../../utils/lib/sign";
import baseConfig from "../../../public/config.json";

// 获取新商城列表
export const reqGetNewProductLists = () =>
  HttpGet("/api/public/mall/v2/productlist");

// 获取升级产品计算
export const reqPostProductUpgradeCalc = (bodyJson) =>
  HttpPost("/api/public/mall/v2/product_upgrade_calc", bodyJson);

// 去升级产品
export const reqPostProductUpgrade = (bodyJson) =>
  HttpPost("/api/public/mall/v2/product_upgrade", bodyJson);

// 不登录获取微信code和state
export const reqGetWxOauthToUrl = (url) =>
  HttpGet(`/api/public/wxgzh/getwxoauth2url?redirecturl=${url}`);

// 活动领取账号
export const reqPostReceiveWelfare = (bodyJson) =>
  HttpPost2("/api/public/wxgzh/receivewelfare", bodyJson);

// 获取分享文章的token
export const reqPostWechatSharetToken = (bodyJson) =>
  HttpPost("/api/public/wxgzh/getwechatsharetoken", bodyJson);

// 打开分享文件
export const reqGetShowWechatShareDoc = (bodyJson) =>
  HttpPost(`/api/public/sharedoc/getinfo`, bodyJson);

// 分享注册
export const reqPostWeixinRegLoginByShare = (req) =>
  HttpPost("/api/public/share_register/reg", req);

// 判断用户是否注册
export const reqPostWeixinIfReg = (req) =>
  HttpPost2("/api/public/ifreg/wx", req);

// 判断用户是否以前有运营商
export const reqGetRegFromAgent = () =>
  HttpGet(`/api/public/mall/getregfromagent`);
